import React from 'react'
import { Container } from '@ui/wrapper'
import BoxImage from '@components/box-image/layout-12'
import { SectionWrapper, StyledText } from './style'

const PressekontaktArea = ({ data, ...rest }) => {
  return (
    <SectionWrapper {...rest}>
      <Container>
        {data.items?.map(
          (item) =>
            item && (
              <BoxImage
                key={item.id}
                title={item.title}
                leftCol={item.images.length ? 6 : 0}
                rightCol={item.images.length ? 6 : 12}
                desc={item.description}
                images={item.images}
                name={item.name}
              >
                {item.texts?.map((text, i) => (
                  <React.Fragment key={i}>
                    <StyledText
                      key={i}
                      style={{ marginLeft: 0, fontSize: '15px' }}
                      dangerouslySetInnerHTML={{
                        __html: text.content
                      }}
                    />
                  </React.Fragment>
                ))}
              </BoxImage>
            )
        )}
      </Container>
    </SectionWrapper>
  )
}

export default PressekontaktArea
